export const Marquee = ({ text = "WE ARE GETTING MARRIED", accent = "CELEBRATE WITH US", bg = "#FF6E00", color = "#FDF9F1" }) => {
  const unit = (
    <span className="inline-flex items-center">
      <span className="font-display text-2xl md:text-4xl px-6 py-4">{text}</span>
      <span className="text-2xl md:text-4xl px-2">✦</span>
      <span className="font-grotesk font-bold uppercase tracking-widest text-sm md:text-base px-6">{accent}</span>
      <span className="text-2xl md:text-4xl px-2">✦</span>
    </span>
  );
  return (
    <div className="marquee border-y-2 border-ink" style={{ backgroundColor: bg, color }} data-testid="marquee">
      <div className="marquee-track">
        {unit}{unit}{unit}{unit}
      </div>
    </div>
  );
};
